import { environment } from "src/environments/environment";
import { AccountSignature } from "../pages/signature/signature.interface";

export interface AccountInfo {
  accountName: string;
  userName: string;
  admin: boolean;
  userId?: any,
  userEmail?: string,
  createdAt?: number,
  superAdmin?: boolean,
  financeiroRole?: boolean,
  administrativeRole?: 'FINANCEIRO' | 'OPERACIONAL' | null,
  accountId?: number
}

export type AuthProvider = 'legacy' | 'keycloak';

export namespace LocalStorageUtil {
  export function setAuthProvider(provider: AuthProvider) {
    localStorage.setItem('auth-provider', provider);
  }

  export function getAuthProvider(): AuthProvider {
    const v = localStorage.getItem('auth-provider');
    return v === 'keycloak' ? 'keycloak' : 'legacy';
  }

  export function setAccountInfo(account: AccountInfo) {
    localStorage.setItem('account-info', JSON.stringify(account));
  }

  export function getAccountInfo(): AccountInfo {
    return JSON.parse(localStorage.getItem('account-info'));
  }

  export function setToken(token: string) {
    localStorage.setItem('token', token);
  }

  export function getToken(): string {
    return localStorage.getItem('token');
  }

  export function setSignature(signature: AccountSignature = null) {
    localStorage.setItem('signature', JSON.stringify(signature));
  }

  export function getSignature(): AccountSignature {
    return JSON.parse(localStorage.getItem('signature'));
  }

  export function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('auth-provider');
    localStorage.removeItem('account-info');
    localStorage.removeItem('signature');

    if(environment.intercom && window.Intercom) {
      window.Intercom('shutdown')
    }
  }
}
